import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[dsRestrictSpecialCharaters]'
})
export class RestrictSpecialCharatersDirective {
  @Input() validateCity: boolean;
  @Input() validateAddress: boolean;

  regexStr = '^[a-zA-Z0-9]*$';
  cityRegexStr = '^[a-zA-Z0-9 \-]*$';
  addressRegexStr = '^[a-zA-Z0-9 ,\-\.\/]+$';

  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    if(this.validateCity) {
      return new RegExp(this.cityRegexStr).test(event.key);
    } else if(this.validateAddress) {
      return new RegExp(this.addressRegexStr).test(event.key);
    } else {
      return new RegExp(this.regexStr).test(event.key);
    }
  }

}
